import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import QrCodePayment from "../../images/qr_banco_biojeck.jpg";
import { FaTrash, FaCheckCircle, FaEdit } from "react-icons/fa"; // Importamos el ícono de basura
import "./Invoices.css";

const Invoices = () => {
  const DRIVER_NAME = `${JSON.parse(localStorage.getItem("user"))[0].name} ${
    JSON.parse(localStorage.getItem("user"))[0].surname
  }`;
  const ROLE = JSON.parse(localStorage.getItem("user"))[0].role;

  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [buttonGetQrPayment, setButtonGetQrPayment] = useState(false);
  const [modalOpenQrPayment, setModalOpenQrPayment] = useState(false);

  const [contractNumber, setContractNumber] = useState("");
  const [contractInfo, setContractInfo] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // Estado para la selección de residuos
  const [wasteType, setWasteType] = useState("");
  const [hazardousWaste, setHazardousWaste] = useState("");
  const [hazardousWasteInput, setHazardousWasteInput] = useState("");
  const [selectedWaste, setSelectedWaste] = useState("");
  const [selectedWasteInput, setSelectedWasteInput] = useState("");
  const [wasteAmount, setWasteAmount] = useState("");
  const [packagingType, setPackagingType] = useState(""); // Tipo de embalaje
  const [packagingAmount, setPackagingAmount] = useState(""); // Cantidad de embalaje
  const [wasteList, setWasteList] = useState([]);
  const [totalKilos, setTotalKilos] = useState(0);

  // Estado para la venta de insumos
  const [insumoType, setInsumoType] = useState("");
  const [insumoAmount, setInsumoAmount] = useState("");
  const [insumoPrice, setInsumoPrice] = useState("");
  const [insumoList, setInsumoList] = useState([]);
  const [valueInsumoTotal, setValueInsumoTotal] = useState(0);
  const [totalSale, setTotalSale] = useState(0);

  // Estado del medio de pago
  const [paymentMethod, setPaymentMethod] = useState("");

  // Modal de éxito
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [maxKilos, setMaxKilos] = useState(0);
  const [kilosAdicionales, setKilosAdicionales] = useState(0);
  const [totalAPagarKilosAdicionales, setTotalAPagarKilosAdicionales] =
    useState(0);

  const [listProducts, setListProducts] = useState([]);

  const [isEditVehiclePlate, setIsEditVehiclePlate] = useState(false);
  const [vehiclePlate, setVehiclePlate] = useState("");
  const [nextConsecutive, setNextConsecutive] = useState(0);
  const [description, setDescription] = useState("");

  const currentDate = format(new Date().toISOString(), "yyyy-MM-dd");

  const valueKilosAdicionales = 3700;
  const valueKilosAdicionalesEmpresarial = 2100;

  const API_URL = process.env.REACT_APP_API_URL;

  const hazardousOptions = {
    biological: [
      "Biosanitarios",
      "Anatomopatológicos",
      "Cortopunzantes",
      "Animales",
    ],
    chemicals: [
      "Fármacos",
      "Citotóxicos",
      "Metales pesados",
      "Reactivos",
      "Aceites usados",
    ],
    administrative: ["Luminarias", "Toners", "RAEES", "Baterías", "Otro"],
  };

  const navigate = useNavigate();

  const getTime = async () =>{
    const now = new Date();
    const hour = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    const currentTime = `${hour}:${minutes}`;

    return currentTime;
  }

  const getNextConsecutive = async () => {
    try {
      const response = await fetch(`${API_URL}/get-next-consecutive-invoice`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
  
      if (!response.ok) {
        throw new Error(`Error en la respuesta del servidor: ${response.status}`);
      }
  
      const result = await response.json();
      if (result.nextConsecutive) {
        setNextConsecutive(result.nextConsecutive);
        return result.nextConsecutive; // Devuelve el consecutivo
      } else {
        console.log("No se pudo consultar los insumos");
        return null;
      }
    } catch (error) {
      console.error("Error al obtener el consecutivo:", error);
      return null;
    }
  };

  useEffect(() => {
    getProducts();
    setVehiclePlate(JSON.parse(localStorage.getItem("user"))[0].vehicle_plate);
    getNextConsecutive();
  }, []);

  const clearFormInvoice = () => {
    setWasteType("");
    setHazardousWaste("");
    setHazardousWasteInput("");
    setSelectedWaste("");
    setSelectedWasteInput("");
    setWasteAmount("");
    setPackagingType("");
    setPackagingAmount("");
    setWasteList([]);
    setTotalKilos(0);
    setInsumoType("");
    setInsumoAmount("");
    setInsumoPrice("");
    setInsumoList([]);
    setValueInsumoTotal(0);
    setTotalSale(0);
    setPaymentMethod("");
    setMaxKilos(0);
    setKilosAdicionales(0);
    setTotalAPagarKilosAdicionales(0);
    setDescription("");
  };

  const sendEmailWithPdfs = (invoicePdfUrl, manifestPdfUrl, recipientEmail) => {
    fetch(`${API_URL}/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            email: recipientEmail,
            invoicePdfUrl,
            manifestPdfUrl
        }),
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error(`Error en la respuesta del servidor: ${response.status}`);
        }
        return response.json();
    })
    .then((data) => {
      setIsLoading(false); // Ocultar modal de carga
    })
    .catch((error) => {
        console.error("Error al enviar el correo:", error);
        alert("Hubo un problema al enviar el correo.");
    });
};

  const handleNewWasteType = () => {
    if (!wasteAmount || !packagingType || !packagingAmount) {
      alert(
        "Por favor, completa todos los campos antes de agregar un residuo."
      );
      return;
    }

    const newWaste = {
      wasteType: wasteType === "non-hazardous" ? (selectedWasteInput === '' ? selectedWaste : selectedWasteInput) : (hazardousWasteInput === '' ? hazardousWaste : hazardousWasteInput),
      wasteAmount,
      packagingType,
      packagingAmount,
    };
    const newTotalKilos = totalKilos + parseFloat(wasteAmount);

    setWasteList([...wasteList, newWaste]);
    setTotalKilos(newTotalKilos);

    if (newTotalKilos > maxKilos) {
      const payInsumosTotal = insumoList.reduce(
        (total, insumo) =>
          parseFloat(total) +
          parseFloat(insumo.insumoAmount) * parseFloat(insumo.insumoPrice),
          0 // Inicia con el valor del contrato
      );
      const additionalKilos = newTotalKilos - maxKilos;
      const additionalPayment =
        contractInfo.ruta === "EMPRESARIAL"
          ? additionalKilos * valueKilosAdicionalesEmpresarial
          : additionalKilos * valueKilosAdicionales;

      setKilosAdicionales(additionalKilos);
      setTotalAPagarKilosAdicionales(additionalPayment);
      setTotalSale(parseFloat(contractInfo.valor) + additionalPayment + payInsumosTotal);
    }
    // Limpiar valores después de agregar el residuo
    setWasteType("");
    setWasteAmount("");
    setSelectedWaste("");
    setSelectedWasteInput("");
    setHazardousWaste("");
    setHazardousWasteInput("");
    setPackagingType("");
    setPackagingAmount("");
  };

  const handleDeleteWaste = (index) => {
    const wasteListDeleted = wasteList.filter((_, i) => i === index);
    // Eliminar el residuo de la lista
    const newWasteList = wasteList.filter((_, i) => i !== index);
    setWasteList(newWasteList);

    // Actualizar el total de kilos
    const newTotalKilos = newWasteList.reduce(
      (total, waste) => total + parseFloat(waste.wasteAmount),
      0
    );

    const newTotalKilosAdicionales = wasteListDeleted.reduce(
      (total, waste) => total - parseFloat(waste.wasteAmount),
      kilosAdicionales
    );

    const totalPayInsumos = insumoList.reduce(
      (total, insumo) => total + parseFloat(insumo.insumoPrice),
      0
    );

    if (newTotalKilosAdicionales > 0) {
      const newTotalAPagarKilosAdicionales =
        contractInfo.ruta === "EMPRESARIAL"
          ? newTotalKilosAdicionales * valueKilosAdicionalesEmpresarial
          : newTotalKilosAdicionales * valueKilosAdicionales;
      const newTotalSale =
      parseFloat(contractInfo.valor) + newTotalAPagarKilosAdicionales + totalPayInsumos;
      setTotalAPagarKilosAdicionales(newTotalAPagarKilosAdicionales);
      setTotalSale(newTotalSale);
    } else {
      setTotalAPagarKilosAdicionales(0);
      setTotalSale(parseFloat(contractInfo.valor) + totalPayInsumos);
    }

    setTotalKilos(newTotalKilos);
    setKilosAdicionales(newTotalKilosAdicionales);
  };

  const handleDeleteInsumo = (index) => {
    // Eliminar el insumo de la lista
    const newInsumoList = insumoList.filter((_, i) => i !== index);
    setInsumoList(newInsumoList);

    // Restar el valor del insumo eliminado al total de la venta
    const newTotalSale = newInsumoList.reduce(
      (total, insumo) =>
        parseFloat(total) +
        parseFloat(insumo.insumoAmount) * parseFloat(insumo.insumoPrice),
        parseFloat(contractInfo.valor) // Inicia con el valor del contrato
    );
    setTotalSale(newTotalSale + totalAPagarKilosAdicionales);
  };

  const handleNewInsumo = () => {
    if (!insumoAmount || !insumoPrice || !insumoType) {
      alert("Por favor, completa todos los campos antes de agregar un insumo.");
      return;
    }

    const newInsumo = {
      insumoType,
      insumoAmount: parseFloat(insumoAmount),
      insumoPrice: parseFloat(insumoPrice),
    };

    setInsumoList([...insumoList, newInsumo]);
    const totalInsumo = newInsumo.insumoAmount * newInsumo.insumoPrice;
    setValueInsumoTotal(totalInsumo);
    setTotalSale(totalSale + totalInsumo);

    // Limpiar valores después de agregar el insumo
    setInsumoType("");
    setInsumoAmount("");
    setInsumoPrice("");
  };

  const handleSearchContract = () => {
    if (!contractNumber.trim()) {
      setErrorMessage("Por favor, ingresa un número de contrato.");
      setContractInfo(null);
      return;
    }

    fetch(`${API_URL}/contracts/${contractNumber}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result && result.contract) {
          clearFormInvoice();
          setContractInfo(result.contract);
          setErrorMessage("");
          setTotalSale(parseFloat(result.contract.valor)); // Inicializamos el total con el valor del contrato
          setMaxKilos(getMaxKilos(result.contract.kilos));
        } else {
          console.log(ROLE);
          
          setContractInfo(null);
          setErrorMessage(
            ROLE === "conductor"
              ? "No se encontró un contrato con este número, por favor contactarse con el administrador."
              : "No se encontró un contrato con este número."
          );
        }
      })
      .catch(() => {
        setErrorMessage("Hubo un error al buscar el contrato.");
        setContractInfo(null);
      });
  };

  const handleGenerateInvoice = async () => {
    const stringWasteDetails = JSON.stringify(wasteList || []);
    if (!paymentMethod) return;
    const nextConsecutiveConst = await getNextConsecutive();
    const timeFactura = await getTime();
    if (!nextConsecutiveConst) {
      alert("No se pudo obtener el consecutivo de la factura.");
      return;
    }
    if (nextConsecutiveConst === 0) {
      alert("Numero consecutivo incorrecto, favor recargar la página");
      return;
    }

    
  
    const invoiceDataToPDF = {
      consecutivo: nextConsecutiveConst,
      state_invoice: "ACTIVO",
      no_contrato: contractInfo.no_contrato,
      type_sale: "N/A",
      nombre_establecimiento: contractInfo.nombre_establecimiento,
      representante: contractInfo.representante,
      direccion: contractInfo.direccion,
      correo: contractInfo.correo,
      fecha_factura: currentDate !== format(new Date().toISOString(), "yyyy-MM-dd") ? format(new Date().toISOString(), "yyyy-MM-dd") : currentDate,
      time_factura: timeFactura,
      vehicle_plate: vehiclePlate,
      driver_name: DRIVER_NAME,
      details_string: stringWasteDetails,
      payment_method: paymentMethod,
      total_sale: totalSale,
      wasteDetails: wasteList,
      insumoDetails: insumoList,
      description: description || "N/A",
    };

    setIsLoading(true); // Activar modal de carga

    fetch(`${API_URL}/generate-invoice`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(invoiceDataToPDF), // ✅ Se convierte en JSON
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Error en la respuesta del servidor: ${response.status}`
          );
        }
        return response.json();
      })
      .then((data) => {
        if(data.pdfInvoice && data.pdfManifest){
          sendEmailWithPdfs(data.pdfInvoice, data.pdfManifest, contractInfo.correo);
        }
        if (data.qrCodeUrl) {
          setIsModalOpen(true);
          setQrCodeUrl(data.qrCodeUrl);
          setTimeout(() => {
            setIsModalOpen(false);
            setModalOpen(true);
          }, 3000);
        } else {
          alert("No se pudo generar el código QR.");
        }
      })
      .catch((error) => {
        console.error("Error al generar la factura:", error);
        alert("Hubo un problema al generar la factura.");
      });
  };

  const getMaxKilos = (rangeString) => {
    const parts = rangeString.split(" - ");
    return Number(parts[1]);
  };

  const getProducts = () => {
    fetch(`${API_URL}/products`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListProducts(result.result);
        } else {
          console.log("No se pudo consultar los insumos");
        }
      });
  };

  const searchInsumo = (product) => {
    fetch(`${API_URL}/products/${product}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result && result?.product) {
          setInsumoPrice(result.product.precio_insumo);
          console.log(result);
        } else {
          console.log("No se encontro el insumo");
        }
      })
      .catch(() => {
        console.log("Error de servidor");
      });
  };

  return (
    <div className="invoices-container">
      <h2>Búsqueda de Contratos</h2>
      <div className="search-form">
        <label htmlFor="contractNumber">Número de Contrato</label>
        <input
          type="text"
          id="contractNumber"
          placeholder="Escribe el número de contrato"
          value={contractNumber}
          onChange={(e) => setContractNumber(e.target.value)}
        />
        <button className="btn-search" onClick={handleSearchContract}>
          Buscar Contrato
        </button>
        <Link className="btn-express" to="/invoices-express">
          Venta Express
        </Link>
      </div>

      {errorMessage && (
        <div className="search-form">
          <h3 className="error-message">{errorMessage}</h3>
          {ROLE !== "conductor" && (
            <Link className="btn-search" to="/contracts">
              Para registrar un nuevo contrato ¡Clic aquí!
            </Link>
          )}
        </div>
      )}

      {contractInfo && (
        <div className="contract-details">
          <h3>Información del Contrato</h3>
          <p>
            <strong>Número de Contrato:</strong> {contractInfo.no_contrato}
          </p>
          <p>
            <strong>Nombre del Establecimiento:</strong>{" "}
            {contractInfo.nombre_establecimiento}
          </p>
          <p>
            <strong>Representante Legal:</strong> {contractInfo.representante}
          </p>
          <p>
            <strong>Ruta:</strong> {contractInfo.ruta}
          </p>
          <p>
            <strong>Dirección:</strong> {contractInfo.direccion}
          </p>
          <p>
            <strong>Teléfono:</strong> {contractInfo.telefono}
          </p>
          <p>
            <strong>Correo:</strong> {contractInfo.correo}
          </p>
          <p>
            <strong>Plan:</strong> {contractInfo.plan}
          </p>
          <p>
            <strong>Insumos:</strong> {contractInfo.insumos}
          </p>
          <p>
            <strong>Kilos:</strong> {contractInfo.kilos}
          </p>
          <p>
            <strong>Valor:</strong> {contractInfo.valor}
          </p>
        </div>
      )}

      {contractInfo && (
        <div className="waste-registration">
          <div className="container-dates-invoice">
            <strong>Fecha actual: {currentDate !== format(new Date().toISOString(), "yyyy-MM-dd") ? format(new Date().toISOString(), "yyyy-MM-dd") : currentDate}</strong>
            <strong>Numero consecutivo de factura: {nextConsecutive}</strong>
          </div>
          <h3>Registro de recolección</h3>
          <div className="waste-type-selection">
            <label>
              <input
                type="radio"
                value="non-hazardous"
                checked={wasteType === "non-hazardous"}
                onChange={() => setWasteType("non-hazardous")}
              />
              Residuos No Peligrosos
            </label>
            <label>
              <input
                type="radio"
                value="hazardous"
                checked={wasteType === "hazardous"}
                onChange={() => setWasteType("hazardous")}
              />
              Residuos Peligrosos
            </label>
          </div>

          {wasteType && (
            <div>
              <div className="form-recolected">
                {wasteType === "non-hazardous" ? (
                  <div>
                    {selectedWaste === 'Otro' && (
                      <label>
                        Tipo:
                        <input
                          type="text"
                          value={selectedWasteInput}
                          onChange={(e) => setSelectedWasteInput(e.target.value)}
                          placeholder="Digita el tipo de residuo"
                        />
                      </label>
                    )}

                    <label>
                      Tipo de Residuo:
                      <select
                        value={selectedWaste}
                        onChange={(e) => setSelectedWaste(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Selecciona un tipo de residuo
                        </option>
                        <option value="Biodegradables">Biodegradables</option>
                        <option value="Reciclables">Reciclables</option>
                        <option value="Inertes">Inertes</option>
                        <option value="Ordinarios">Ordinarios</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </label>
                  </div>
                ) : (
                  <div>
                    {hazardousWaste === 'Otro' && (
                      <label>
                        Tipo:
                        <input
                          type="text"
                          value={hazardousWasteInput}
                          onChange={(e) => setHazardousWasteInput(e.target.value)}
                          placeholder="Digita el tipo de residuo"
                        />
                      </label>
                    )}
                  <label>
                    Tipo de Residuo Peligroso:
                    <select
                      value={hazardousWaste}
                      onChange={(e) => setHazardousWaste(e.target.value)}
                    >
                      <option value="" disabled selected>
                        Selecciona un tipo de residuo peligroso
                      </option>
                      {Object.values(hazardousOptions)
                        .flat()
                        .map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                    </select>
                  </label>
                  </div>
                )}

                <label>
                  Cantidad en kg:
                  <input
                    type="number"
                    value={wasteAmount}
                    onChange={(e) => setWasteAmount(e.target.value)}
                  />
                </label>
              </div>
              <div className="form-recolected">
                <label>
                  Tipo de Embalaje:
                  <select
                    value={packagingType}
                    onChange={(e) => setPackagingType(e.target.value)}
                  >
                    <option value="" disabled selected>
                      Selecciona el tipo de embalaje
                    </option>
                    <option value="Guardian">Guardian</option>
                    <option value="Bolsa">Bolsa</option>
                    <option value="Caja">Caja</option>
                    <option value="Galón">Galón</option>
                  </select>
                </label>

                <label>
                  Cantidad de Embalaje:
                  <input
                    type="number"
                    value={packagingAmount}
                    onChange={(e) => setPackagingAmount(e.target.value)}
                  />
                </label>
              </div>
            </div>
          )}

          <button
            className="btn-search mb-5"
            onClick={handleNewWasteType}
            disabled={!wasteAmount || !packagingType || !packagingAmount}
          >
            Agregar residuo
          </button>

          <ul className="container-list-invoice">
            {wasteList.map((item, index) => (
              <li key={index} className="waste-item">
                <span>
                  {item.wasteType} - {item.wasteAmount} kg, Embalaje:{" "}
                  {item.packagingType} ({item.packagingAmount} unidades)
                </span>
                <button
                  className="delete-btn"
                  onClick={() => handleDeleteWaste(index)}
                >
                  <FaTrash size={16} />
                </button>
              </li>
            ))}
          </ul>
          <div className="total-kilos">
            <strong>Total de kilos: {totalKilos} kg</strong>
            {totalKilos > maxKilos && (
              <p style={{ color: "red" }}>
                Tenga en cuenta que el máximo de kilos para el plan{" "}
                {contractInfo.plan} es {maxKilos}. A partil del kilo{" "}
                {maxKilos + 1} será adicional.
              </p>
            )}
            {kilosAdicionales > 0 && (
              <div className="total-kilos">
                <p>
                  <strong>Total de kilos adicionales: </strong>{" "}
                  {kilosAdicionales} kg
                </p>
                <p>
                  <strong>Total a pagar por kilos adicionales: </strong>
                  {totalAPagarKilosAdicionales} kg
                </p>
              </div>
            )}
          </div>

          {/* Sección de Venta de Insumos */}
          {wasteList.length > 0 && (
            <div className="insumo-registration">
              <h3>Venta de Insumos</h3>
              <div className="form-recolected">
                <label>
                  Tipo de Insumo:
                  <select
                    id="insumo"
                    value={insumoType}
                    onChange={(e) => {
                      setInsumoType(e.target.value);
                      searchInsumo(e.target.value);
                    }}
                  >
                    <option value="" disabled selected>
                      Selecciona un insumo
                    </option>
                    {listProducts.map((value) => (
                      <option key={value.id} value={value.insumo}>
                        {value.insumo}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Cantidad:
                  <input
                    type="number"
                    value={insumoAmount}
                    onChange={(e) => setInsumoAmount(e.target.value)}
                  />
                </label>

                <label>
                  Precio:
                  <input type="number" value={insumoPrice} disabled />
                </label>
              </div>
              <button
                className="btn-search mb-5"
                onClick={handleNewInsumo}
                disabled={!insumoAmount || !insumoPrice || !insumoType}
              >
                Agregar venta de insumo
              </button>

              <ul className="container-list-invoice">
                {insumoList.map((item, index) => (
                  <li key={index} className="waste-item">
                    <span>
                      {item.insumoType} - {item.insumoAmount} unidades, Precio:
                      ${item.insumoPrice}
                    </span>
                    <button
                      className="delete-btn"
                      onClick={() => handleDeleteInsumo(index)}
                    >
                      <FaTrash size={16} />
                    </button>
                  </li>
                ))}
              </ul>

              {/* Select para medio de pago */}
              <div className="form-recolected">
                <label>
                  Medio de Pago:
                  <select
                    value={paymentMethod}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value);
                      setButtonGetQrPayment(e.target.value !== "Efectivo");
                    }}
                  >
                    <option value="" disabled selected>
                      Selecciona un medio de pago
                    </option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Nequi">Nequi</option>
                    <option value="Daviplata">Daviplata</option>
                    <option value="Abono a cuenta">Abono a cuenta</option>
                  </select>
                </label>
                <label>
                  Placa del vehículo que recolecta:
                  <div className="plate-container">
                    <input
                      type="text"
                      value={vehiclePlate}
                      onChange={(e) => setVehiclePlate(e.target.value)}
                      disabled={!isEditVehiclePlate}
                    />
                    <FaEdit
                      onClick={() => setIsEditVehiclePlate(true)}
                      className="edit-icon"
                      style={{ fontSize: "2.5rem" }}
                    />
                  </div>
                </label>
                <label>
                  Observaciones:
                  <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </label>
                {buttonGetQrPayment && (
                  <button
                    className="btn-search"
                    onClick={() => setModalOpenQrPayment(true)}
                  >
                    Genera QR de pago
                  </button>
                )}
              </div>

              <div className="total-sale">
                <strong>Total de Venta: ${totalSale}</strong>
              </div>

              {/* Modal de éxito */}
              {isModalOpen && (
                <div className="modal-success">
                  <div className="modal-content">
                    <FaCheckCircle
                      size={100}
                      color="green"
                      className="modal-icon"
                    />
                    <h1>¡Factura registrada exitosamente!</h1>
                  </div>
                </div>
              )}

              {/* Botón para generar factura */}
              <button
                className="btn-search mb-5"
                onClick={handleGenerateInvoice}
              >
                Generar Factura
              </button>
              {modalOpen && (
                <div className="modal-success">
                  <div className="modal-content">
                    <h2>Factura Generada</h2>
                    {qrCodeUrl ? (
                      <div>
                        <p>Escanea el código QR para descargar tu factura:</p>
                        <img src={qrCodeUrl} alt="QR Code" />
                      </div>
                    ) : (
                      <p>Generando el código QR...</p>
                    )}
                    <button
                      onClick={() => {
                        setModalOpen(false);
                        navigate("/consult-invoices");
                      }}
                      className="mt-4"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              )}
              {modalOpenQrPayment && (
                <div className="modal-success">
                  <div className="modal-content">
                    <div>
                      <img
                        className="img-qr-payment"
                        src={QrCodePayment}
                        alt="QR Code pago"
                      />
                    </div>
                    <button
                      onClick={() => setModalOpenQrPayment(false)}
                      className="mt-4"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              )}
              {isLoading && (
                <div className="modal-loading">
                  <div className="spinner"></div>
                  <p>Generando factura...</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Invoices;
